// import React, { useContext, useState, useEffect } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Grid,
//   Typography,
//   TextField,
//   Divider,
//   InputAdornment,
//   IconButton,
// } from "@mui/material";
// import ClearIcon from "@mui/icons-material/Clear";
// import {
//   getAllCustomers,
//   createCustomer,
//   createBill,
//   updateCustomer,
//   deleteCustomer,
//   getCustomerMetrics,
//   getMeterDevices,
//   getTagsForDevices,
//   getAllTariffs,
//   getOneDayEnergySum,
// } from "../../../Restclient/datacollection";
// import { ThemeContext } from "../../Homepage";
// import CustomButton from "../../CommonComponents/CustomButton";
// import { useDispatch, useSelector } from "react-redux";
// import CustomMultiSelect from "../../CommonComponents/CustomMultiSelect";
// import CustomActionButton from "../../CommonComponents/CustomActionButton";
// import CustomTextField from "../../CommonComponents/CustomTextField";
// import CustomDropDown from "../../CommonComponents/CustomDropDown";
// import CustomDatePicker from "../../CommonComponents/CustomDatePicker";
// import CustomSelectMenuItem from "../../CommonComponents/CustomSelectMenuItem";
// import CustomDialogBox from "../../CommonComponents/CustomDialogBox";
// import dayjs from "dayjs";
// import CustomToast from "../../CommonComponents/CustomToast";
// import "../../../cssfiles/billing.css";
// import SearchIcon from '../../../images/LK_Search';

// const CustomerActions = ({
//   customer,
//   setCustomers,
//   setCustomerInfo,
//   setOpenForm,
//   setFormMode,
//   setDeleteSuccess,
// }) => {
//   const [openConfirm, setOpenConfirm] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const handleViewClick = () => {
//     if (!customer || !customer.data || !customer.data.customerId) {
//       alert("Cannot view customer - missing data");
//       return;
//     }

//     const customerToView = {
//       id: customer.data.customerId,
//       data: {
//         ...customer.data,
//         prepaid: customer.data.prepaid || "",
//         billingCycle: customer.data.billingCycle || "",
//         billingCycleStart: customer.data.billingCycleStart || "",
//         billingCycleEnd: customer.data.billingCycleEnd || "",
//         tariffId: customer.data.tariffId || "",
//         previousMeterId: customer.data.previousMeterId || "",
//         customerType: customer.data.customerType || "",
//       },
//     };

//     setCustomerInfo(customerToView);
//     setFormMode("view");
//     setOpenForm(true);
//   };

//   const handleUpdateClick = () => {
//     if (!customer || !customer.data || !customer.data.customerId) {
//       alert("Cannot update customer - missing data");
//       return;
//     }

//     const customerToUpdate = {
//       id: customer.data.customerId,
//       data: {
//         customerId: customer.data.customerId,
//         deviceId: customer.data.deviceId,
//         tagId: customer.data.tagId || [],
//         firstName: customer.data.firstName || "",
//         middleName: customer.data.middleName || "",
//         lastName: customer.data.lastName || "",
//         email: customer.data.email || "",
//         phone: customer.data.phone || "",
//         addressLine1: customer.data.addressLine1 || "",
//         addressLine2: customer.data.addressLine2 || "",
//         city: customer.data.city || "",
//         state: customer.data.state || "",
//         country: customer.data.country || "",
//         postalCode: customer.data.postalCode || "",
//         poleNo: customer.data.poleNo || "",
//         isActive: customer.data.isActive ?? true,
//         customerType: customer.data.customerType || "",
//         prepaid: customer.data.prepaid || "",
//         accountCreationDate: customer.data.accountCreationDate || "",
//         initialMeterReading: customer.data.initialMeterReading || "",
//         finalMeterReading: customer.data.finalMeterReading || "",
//         billingCycle: customer.data.billingCycle || "",
//         billingCycleStart: customer.data.billingCycleStart || "",
//         billingCycleEnd: customer.data.billingCycleEnd || "",
//         previousMeterIds: Array.isArray(customer.data.previousMeterIds)
//           ? customer.data.previousMeterIds
//           : [""],
//         previousMeterId: customer.data.previousMeterId || "",
//         sanctionLoad: customer.data.sanctionLoad || "",
//         tariffId: customer.data.tariffId || "",
//         accountStatus: customer.data.accountStatus || "",
//       },
//     };

//     setCustomerInfo(customerToUpdate);
//     setFormMode("update");
//     setOpenForm(true);
//   };

//   const handleDeleteClick = () => {
//     setOpenConfirm(true);
//   };

//   const handleDelete = () => {
//     const customerId = customer.data.customerId;

//     setLoading(true);
//     deleteCustomer(customerId, (response) => {
//       setLoading(false);
//       if (response.success) {
//         setCustomers((prev) =>
//           prev.filter((c) => c.data.customerId !== customerId)
//         );
//         setOpenConfirm(false);
//         setDeleteSuccess(1);
//       } else {
//         setDeleteSuccess(2);
//       }
//     });
//   };

//   return (
//     <>
//       <Box className="customer-actions-container">
//         <CustomActionButton buttonText={"View"} onClick={handleViewClick} />
//         <CustomActionButton buttonText={"Delete"} onClick={handleDeleteClick} />
//         <CustomActionButton buttonText={"Update"} onClick={handleUpdateClick} />
//       </Box>
//       <CustomDialogBox
//         dialogTitle={"Delete Confirmation"}
//         dialogText={`Are you sure you want to delete customer ${customer.data.firstName} ${customer.data.lastName}? This action cannot be undone.`}
//         openDialog={openConfirm}
//         handleCloseDialog={() => setOpenConfirm(false)}
//         handleConfirmDialog={handleDelete}
//         confirmText={"Delete"}
//         cancelText={"Cancel"}
//         type={"Warning"}
//         loading={loading}
//       />
//     </>
//   );
// };

// const CustomerMetrics = () => {
//   const [metrics, setMetrics] = useState({
//     totalCustomers: 0,
//     activeCustomers: 0,
//     inactiveCustomers: 0,
//   });
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchMetrics = async () => {
//       try {
//         setIsLoading(true);
//         const response = await getCustomerMetrics();
//         if (response.state === true && response.metrics) {
//           setMetrics({
//             totalCustomers: response.metrics.totalCustomers,
//             activeCustomers: response.metrics.activeCustomers,
//             inactiveCustomers: response.metrics.inactiveCustomers,
//           });
//         }
//       } catch (error) {
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchMetrics();
//     const interval = setInterval(fetchMetrics, 60000);
//     return () => clearInterval(interval);
//   }, []);

//   const metricsData = [
//     {
//       label: "Total Customers",
//       value: metrics.totalCustomers,
//       color: "var(--PrimaryText)",
//     },
//     {
//       label: "Active Customers",
//       value: metrics.activeCustomers,
//       color: "var(--GreenBaseColor)",
//     },
//     {
//       label: "Inactive Customers",
//       value: metrics.inactiveCustomers,
//       color: "var(--GreyBaseColor)",
//     },
//   ];

//   return (
//     <div className="metrics-card card2">
//       <div className="metrics-container">
//         {metricsData.map((metric, index) => (
//           <React.Fragment key={index}>
//             <div className="metric-item cardtext">
//               <div>
//                 <Typography className="metric-label">
//                   {metric.label}
//                 </Typography>
//               </div>
//               <div>
//                 <Typography
//                   className="metric-value"
//                   style={{ color: metric.color }}
//                 >
//                   {metric.value}
//                 </Typography>
//               </div>
//             </div>
//             {index < metricsData.length - 1 && (
//               <Divider
//                 orientation="vertical"
//                 variant="middle"
//                 className="metric-divider"
//                 flexItem
//               />
//             )}
//           </React.Fragment>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default function UtilityCustomerDashboard(props) {
//   const dispatch = useDispatch();
//   const themechange = useSelector((state) => state.themedata.theme);
//   const [customers, setCustomers] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [openForm, setOpenForm] = useState(false);
//   const [required, setRequired] = useState(false);
//   const [search, setSearch] = useState({ searchText: "", filterSelected: "" });
//   const [isSearching, setIsSearching] = useState(false);
//   const [searchList, setSearchList] = useState([]);
//   const { theme } = useContext(ThemeContext);
//   const [tariffs, setTariffs] = useState([]);
//   const [formMode, setFormMode] = useState("add");
//   const userdetails = useSelector((state) => state.logindata.userdetails);
//   const [devices, setDevices] = useState([]);
//   const [tags, setTags] = useState([]);
//   const [saveStatus, setSaveStatus] = React.useState(0);
//   const [deleteSuccess, setDeleteSuccess] = React.useState(0);

//   const initialCustomerInfo = {
//     id: "",
//     data: {
//       customerId: "",
//       deviceId: "",
//       tagId: [""],
//       firstName: "",
//       middleName: "",
//       lastName: "",
//       customerType: "",
//       email: "",
//       phone: "",
//       addressLine1: "",
//       addressLine2: "",
//       city: "",
//       state: "",
//       country: "",
//       postalCode: "",
//       poleNo: "",
//       isActive: true,
//       prepaid: "",
//       sanctionLoad: "",
//       accountCreationDate: "",
//       billingCycle: "",
//       billingCycleStart: "",
//       billingCycleEnd: "",
//       removalDate: "",
//       reasonForRemoval: "",
//       previousMeterId: "",
//       previousMeterIds: [""],
//       tariffId: "",
//       initialMeterReading: "",
//       finalMeterReading: "",
//       accountStatus: "",
//     },
//   };
//   const [customerInfo, setCustomerInfo] = useState(initialCustomerInfo);

//   const formatFullName = (customer) => {
//     const firstName = customer.data.firstName || "";
//     const middleName = customer.data.middleName || "";
//     const lastName = customer.data.lastName || "";

//     return [firstName, middleName, lastName].filter(Boolean).join(" ") || "-";
//   };

//   const fetchCustomers = async () => {
//     try {
//       setIsLoading(true);
//       const response = await getAllCustomers();
//       if (response && response.state && response.customers) {
//         const formattedCustomers = response.customers.map((customer) => ({
//           id: customer.data.customerId,
//           data: {
//             ...customer.data,
//             prepaid: customer.data.prepaid || "",
//             accountCreationDate: customer.data.accountCreationDate || "",
//             billingCycle: customer.data.billingCycle || "",
//             billingCycleStart: customer.data.billingCycleStart || "",
//             billingCycleEnd: customer.data.billingCycleEnd || "",
//             deviceId: customer.data.deviceId || "",
//             tagId: customer.data.tagId || [],
//             previousMeterIds: customer.data.previousMeterIds || [""],
//             tariffId: customer.data.tariffId || "",
//             customerType: customer.data.customerType || "",
//             status: customer.data.accountStatus || "",
//           },
//         }));

//         setCustomers(formattedCustomers);
//       } else {
//         setError("No customers found");
//         setCustomers([]);
//       }
//     } catch (error) {
//       setError(error.message || "Failed to fetch customers");
//       setCustomers([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!openForm) {
//       fetchCustomers();
//     }
//   }, [openForm]);

//   useEffect(() => {
//     const fetchDevicesTariffsAndTags = async () => {
//       try {
//         const orgId = userdetails?.orgId || userdetails?.Organizationid;
//         const projectId = userdetails?.projectId || userdetails?.Projectid;

//         if (!orgId || !projectId) {
//           setDevices([]);
//           setTags([]);
//           setTariffs([]);
//           return;
//         }

//         getMeterDevices(orgId, projectId, (devicesResponse) => {
//           const { devices = [] } = devicesResponse;

//           if (devicesResponse?.success && devices.length > 0) {
//             const formattedDevices = devices.map((device) => ({
//               id: device.DeviceID,
//               name: `${device.Name || "Meter"} - ${device.SN || ""}`,
//               type: "Standard",
//             }));

//             setDevices(formattedDevices);
//             const deviceIds = formattedDevices.map((device) => device.id);

//             getTagsForDevices(deviceIds, (tagsResponse) => {
//               if (tagsResponse?.success && tagsResponse?.tags) {
//                 const formattedTags = tagsResponse.tags.map((tag) => {
//                   return {
//                     id: tag.id || tag._id || tag.tagId,
//                     name: tag.tagName || tag.name || tag.tagId || "Unknown",
//                     unit: tag.unit || tag.Unit || "",
//                     deviceId: tag.deviceId || tag.DeviceID || "",
//                   };
//                 });

//                 setTags(formattedTags);
//               } else {
//                 setTags([]);
//               }
//             });
//           } else {
//             setDevices([]);
//             setTags([]);
//           }
//         });

//         const tariffsResponse = await getAllTariffs();

//         if (tariffsResponse?.tariffs) {
//           const formattedTariffs = tariffsResponse.tariffs.map((tariff) => {
//             return {
//               id: tariff.id || tariff._id,
//               name: tariff.name || tariff.tariffName || "Unknown",
//               rate: tariff.rate || tariff.unitRate || 0,
//             };
//           });

//           setTariffs(formattedTariffs);
//         } else {
//           setTariffs([]);
//         }
//       } catch (error) {
//         setDevices([]);
//         setTariffs([]);
//         setTags([]);
//       }
//     };

//     fetchDevicesTariffsAndTags();
//   }, [userdetails]);

//   const handleInputChange = (field) => (event) => {
//     const value = event?.target?.value ?? event;

//     if (["firstName", "middleName", "lastName"].includes(field)) {
//       const updatedInfo = { ...customerInfo };
//       updatedInfo.data[field] = value;

//       const fullName = [
//         updatedInfo.data.firstName,
//         updatedInfo.data.middleName,
//         updatedInfo.data.lastName,
//       ]
//         .filter(Boolean)
//         .join(" ");

//       updatedInfo.data.name = fullName;
//       setCustomerInfo(updatedInfo);
//     } else {
//       setCustomerInfo((prev) => ({
//         ...prev,
//         data: {
//           ...prev.data,
//           [field]: value,
//         },
//       }));
//     }
//   };

//   const handleSaveOrUpdate = async () => {
//     try {
//       if (!customerInfo || !customerInfo.data) {
//         setRequired(1);
//         setOpenForm(1);
//         return;
//       }

//       const mandatoryFields = {
//         firstName: customerInfo.data.firstName,
//         lastName: customerInfo.data.lastName,
//         phone: customerInfo.data.phone,
//         addressLine1: customerInfo.data.addressLine1,
//         city: customerInfo.data.city,
//         state: customerInfo.data.state,
//         country: customerInfo.data.country,
//         deviceId: customerInfo.data.deviceId,
//         tariffId: customerInfo.data.tariffId,
//       };

//       const missingFields = Object.entries(mandatoryFields)
//         .filter(
//           ([key, value]) =>
//             !value || (typeof value === "string" && value.trim() === "")
//         )
//         .map(([key]) => key);

//       if (missingFields.length > 0) {
//         alert(
//           `Please fill in the following required fields: ${missingFields.join(
//             ", "
//           )}`
//         );
//         setRequired(1);
//         setOpenForm(1);
//         return;
//       }

//       setIsLoading(true);

//       if (customerInfo.id || customerInfo.data.customerId) {
//         const customerId = customerInfo.data.customerId || customerInfo.id;

//         const updatePayload = { ...customerInfo.data };

//         if (updatePayload.removalDate && updatePayload.reasonForRemoval) {
//           updatePayload.previousMeterIds = [
//             ...(customerInfo.data.previousMeterIds || []),
//             {
//               meterId: customerInfo.data.deviceId,
//               tagId: customerInfo.data.tagId,
//               removalDate: updatePayload.removalDate,
//               reasonForRemoval: updatePayload.reasonForRemoval,
//               initialReading: customerInfo.data.initialMeterReading,
//               finalReading: "TBD",
//               unitsConsumed: "TBD",
//             },
//           ];

//           if (!customerInfo.data.deviceId) {
//             updatePayload.deviceId = "";
//           }
//           if (
//             !customerInfo.data.tagId ||
//             customerInfo.data.tagId.length === 0
//           ) {
//             updatePayload.tagId = "";
//           }
//         }

//         updateCustomer(customerId, updatePayload, (response) => {
//           if (response.success) {
//             setCustomers((prev) =>
//               prev.map((c) =>
//                 c.data.customerId === customerId
//                   ? { id: customerId, data: response.customer }
//                   : c
//               )
//             );

//             setSaveStatus(1);

//             setTimeout(() => {
//               setOpenForm(false);
//               setCustomerInfo(initialCustomerInfo);
//               setFormMode("add");
//               setTimeout(() => setSaveStatus(0), 5000);
//             }, 5000);
//           } else {
//             setSaveStatus(2);
//             setRequired(1);
//             setOpenForm(1);
//             setTimeout(() => setSaveStatus(0), 5000);
//           }

//           setIsLoading(false);
//         });

//         return;
//       }

//       try {
//         const response = await createCustomer(customerInfo, userdetails.Email);

//         if (response.success) {
//           const tagId = customerInfo.data.tagId;
//           const customerId =
//             response.customer.data?.customerId || response.customer.id;
//           const today = new Date().toISOString().split("T")[0];

//           if (!tagId || (Array.isArray(tagId) && tagId.length === 0)) {
//             setCustomers((prev) => [...prev, response.customer]);
//             setSaveStatus(1);

//             setTimeout(() => {
//               setOpenForm(false);
//               setCustomerInfo(initialCustomerInfo);
//               setFormMode("add");
//               setTimeout(() => setSaveStatus(0), 5000);
//             }, 5000);

//             setIsLoading(false);
//             return;
//           }

//           const tagIds = Array.isArray(tagId) ? tagId : [tagId];

//           try {
//             const energyPromises = tagIds.map(
//               (singleTagId) =>
//                 new Promise((resolve, reject) => {
//                   getOneDayEnergySum(singleTagId, today, (energyResponse) => {
//                     if (energyResponse.success) {
//                       const energyValue = energyResponse.energySum || 0;
//                       resolve(energyValue);
//                     } else {
//                       resolve(0);
//                     }
//                   });
//                 })
//             );

//             const energySums = await Promise.all(energyPromises);

//             const totalEnergySum = energySums.reduce(
//               (sum, current) => sum + current,
//               0
//             );

//             if (!customerId) {
//               throw new Error("Customer ID is missing for bill creation");
//             }

//             const billPayload = {
//               customerId: customerId,
//               tagId: tagIds,
//               energySum: totalEnergySum,
//               date: today,
//             };

//             const billResponse = await createBill(billPayload);

//             if (!billResponse.success) {
//             }
//           } catch (billError) {
//           }

//           setCustomers((prev) => [...prev, response.customer]);
//           setSaveStatus(1);

//           setTimeout(() => {
//             setOpenForm(false);
//             setCustomerInfo(initialCustomerInfo);
//             setFormMode("add");
//             setTimeout(() => setSaveStatus(0), 5000);
//           }, 5000);
//         } else {
//           throw new Error(response.error || "Failed to create customer");
//         }
//       } catch (createError) {
//         alert(
//           "Error creating customer: " +
//             (createError.message || "Unknown error occurred")
//         );
//         setSaveStatus(2);
//         setRequired(1);
//         setOpenForm(1);
//       } finally {
//         setIsLoading(false);
//       }
//     } catch (error) {
//       alert("Error: " + (error.message || "Unknown error occurred"));
//       setSaveStatus(2);
//       setRequired(1);
//       setOpenForm(1);
//       setIsLoading(false);
//     }
//   };

//   const handleToastClose = () => {
//     setSaveStatus(0);
//   };

//   const handleDeleteToastClose = () => {
//     setDeleteSuccess(0);
//   };

//   const handleSearchClick = async () => {
//     try {
//       setIsLoading(true);
//       const response = await getAllCustomers();

//       if (response && response.customers) {
//         const filteredCustomers = response.customers.filter((customer) => {
//           const fullName = [
//             customer.data.firstName,
//             customer.data.middleName,
//             customer.data.lastName,
//           ]
//             .filter(Boolean)
//             .join(" ")
//             .toLowerCase();
//           const searchLower = search.searchText.toLowerCase();
//           if (!searchLower) return true;
//           return (
//             fullName.includes(searchLower) ||
//             customer.data.firstName.toLowerCase().includes(searchLower) ||
//             customer.data.lastName.toLowerCase().includes(searchLower) ||
//             (customer.data.middleName &&
//               customer.data.middleName.toLowerCase().includes(searchLower))
//           );
//         });

//         setSearchList(filteredCustomers);
//         setIsSearching(true);
//       }
//     } catch (err) {
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSearchCancel = () => {
//     setSearch({ searchText: "", filterSelected: "" });
//     setSearchList([]);
//     setIsSearching(false);
//   };

//   const handleKeyPress = (event) => {
//     if (event.key === "Enter") {
//       handleSearchClick();
//     }
//   };

//   const availableDevices = devices.filter((device) => {
//     return !customerInfo.data.previousMeterIds.some(
//       (prev) => prev.meterId === device.id
//     );
//   });

//   const displayCustomers = isSearching ? searchList : customers;

//   const renderFieldValue = (value) => {
//     return (
//       <Box className={`field-value field-value--${themechange}`}>
//         {value || "-"}
//       </Box>
//     );
//   };

//   const renderAddCustomerForm = () => {
//     if (!customerInfo) return null;

//     const isViewMode = formMode === "view";
//     const isUpdateMode = formMode === "update" && customerInfo.id;
//     const isDisabled = isViewMode || (isUpdateMode && formMode === "update");

//     return (
//       <Box className={`form-container form-container--${themechange}`}>
//         <Typography
//           variant="h5"
//           className={`form-title form-title--${themechange}`}
//         >
//           {isViewMode
//             ? "View Customer"
//             : customerInfo.id
//             ? "Update Customer"
//             : "Add New Customer"}
//         </Typography>

//         <Box className="form-section">
//           <Typography variant="h6" className="section-title">
//             Personal Information
//           </Typography>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   First Name
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.firstName)
//                 ) : (
//                   <CustomTextField
//                     id={"first-name-input"}
//                     onChange={handleInputChange("firstName")}
//                     defaultValue={customerInfo.data.firstName}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Middle Name
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.middleName)
//                 ) : (
//                   <CustomTextField
//                     id={"middle-name-input"}
//                     onChange={handleInputChange("middleName")}
//                     defaultValue={customerInfo.data.middleName}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Last Name
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.lastName)
//                 ) : (
//                   <CustomTextField
//                     id={"last-name-input"}
//                     onChange={handleInputChange("lastName")}
//                     defaultValue={customerInfo.data.lastName}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Email
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.email)
//                 ) : (
//                   <CustomTextField
//                     id={"email-input"}
//                     onChange={handleInputChange("email")}
//                     defaultValue={customerInfo.data.email}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Phone
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.phone)
//                 ) : (
//                   <CustomTextField
//                     id={"phone-input"}
//                     onChange={handleInputChange("phone")}
//                     defaultValue={customerInfo.data.phone}
//                     disabled={isViewMode}
//                     maxLength={10}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>

//         <Box className="form-section">
//           <Typography variant="h6" className="section-title">
//             Address Details
//           </Typography>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Address Line 1
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.addressLine1)
//                 ) : (
//                   <CustomTextField
//                     id={"address-input"}
//                     onChange={handleInputChange("addressLine1")}
//                     defaultValue={customerInfo.data.addressLine1}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Address Line 2
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.addressLine2)
//                 ) : (
//                   <CustomTextField
//                     id={"address-input"}
//                     onChange={handleInputChange("addressLine2")}
//                     defaultValue={customerInfo.data.addressLine2}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   City
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.city)
//                 ) : (
//                   <CustomTextField
//                     id={"city-input"}
//                     onChange={handleInputChange("city")}
//                     defaultValue={customerInfo.data.city}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   State
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.state)
//                 ) : (
//                   <CustomTextField
//                     id={"state-input"}
//                     onChange={handleInputChange("state")}
//                     defaultValue={customerInfo.data.state}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Country
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.country)
//                 ) : (
//                   <CustomTextField
//                     id={"country-input"}
//                     onChange={handleInputChange("country")}
//                     defaultValue={customerInfo.data.country}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Postal Code
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.postalCode)
//                 ) : (
//                   <CustomTextField
//                     id={"postal-code-input"}
//                     onChange={handleInputChange("postalCode")}
//                     defaultValue={customerInfo.data.postalCode}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Pole Number
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.poleNo)
//                 ) : (
//                   <CustomTextField
//                     id={"pole-number-input"}
//                     onChange={handleInputChange("poleNo")}
//                     defaultValue={customerInfo.data.poleNo}
//                     disabled={isViewMode}
//                     maxLength={50}
//                     width={500}
//                   />
//                 )}
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>

//         <Box className="form-section">
//           <Typography variant="h6" className="section-title">
//             Other Account Details
//           </Typography>
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--narrow field-label--${themechange}`}>
//                   Customer Type
//                   <span className="required-asterisk">*</span>
//                 </Typography>

//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.customerType)
//                 ) : (
//                   <>
//                     <CustomDropDown
//                       id={"customer-type-input"}
//                       onChange={(e) => handleInputChange("customerType")(e)}
//                       options={["Residential", "Commercial", "Industrial"]}
//                       disabled={isUpdateMode}
//                       defaultValue={customerInfo.data.customerType || ""}
//                       width={210}
//                     ></CustomDropDown>
//                   </>
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Sanction Load
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.sanctionLoad)
//                 ) : (
//                   <CustomTextField
//                     id={"sanction-load-input"}
//                     onChange={handleInputChange("sanctionLoad")}
//                     defaultValue={customerInfo.data.sanctionLoad}
//                     disabled={isViewMode}
//                     maxLength={10}
//                     width={450}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--narrow field-label--${themechange}`}>
//                   Account Status
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.accountStatus)
//                 ) : (
//                   <CustomDropDown
//                     id={"account-status-input"}
//                     onChange={(e) => handleInputChange("accountStatus")(e)}
//                     options={["Active", "Inactive"]}
//                     defaultValue={customerInfo.data.accountStatus || ""}
//                     disabled={isViewMode}
//                     width={210}
//                   ></CustomDropDown>
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--narrow field-label--${themechange}`}>
//                   Prepaid
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.prepaid)
//                 ) : (
//                   <>
//                     <CustomDropDown
//                       id={"prepaid-input"}
//                       onChange={handleInputChange("prepaid")}
//                       options={["Yes", "No"]}
//                       defaultValue={customerInfo.data.prepaid || "No"}
//                       disabled={isViewMode}
//                       width={210}
//                     />
//                   </>
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box config--form--box--narrow">
//                 <Typography className={`field-label field-label--narrow field-label--${themechange}`}>
//                   Billing Cycle
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.billingCycle)
//                 ) : (
//                   <CustomDropDown
//                     id={"billing-Cycle-input"}
//                     onChange={(e) => handleInputChange("billingCycle")(e)}
//                     options={["Monthly"]}
//                     defaultValue={customerInfo.data.billingCycle || "Monthly"}
//                     disabled={isUpdateMode}
//                     width={210}
//                   ></CustomDropDown>
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--date field-label--${themechange}`}>
//                   Billing Cycle Start
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.billingCycleStart)
//                 ) : (
//                   <CustomDatePicker
//                     name={"billingCycleStart"}
//                     onChange={(date) => {
//                       const event = { target: { value: date } };
//                       handleInputChange("billingCycleStart")(event);
//                     }}
//                     views={["day", "month", "year"]}
//                     width={224}
//                     defaultValue={
//                       customerInfo.data.billingCycleStart
//                         ? dayjs(customerInfo.data.billingCycleStart)
//                         : null
//                     }
//                     placeholder={"DD/MM/YYYY"}
//                     disabled={isUpdateMode}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--narrow field-label--${themechange}`}>
//                   Meter ID
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.deviceId)
//                 ) : (
//                   <>
//                     <CustomSelectMenuItem
//                       id={"device-id-input"}
//                       onChange={handleInputChange("deviceId")}
//                       options={availableDevices}
//                       defaultValue={customerInfo.data.deviceId || ""}
//                       width={210}
//                     />
//                   </>
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--narrow field-label--${themechange}`}>
//                   Tag IDs
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(
//                     Array.isArray(customerInfo.data.tagId)
//                       ? customerInfo.data.tagId.join(", ")
//                       : customerInfo.data.tagId
//                   )
//                 ) : (
//                   <>
//                     <CustomMultiSelect
//                       names={
//                         tags
//                           ?.filter(
//                             (tag) =>
//                               tag.unit === "kWh" || tag.unit === "kVAh"
//                           )
//                           .filter(
//                             (tag) => tag.deviceId === customerInfo.data.deviceId
//                           )
//                           .map((tag) => `${tag.name} (${tag.unit})`) || []
//                       }
//                       defaultValue={(customerInfo.data.tagId || []).map(
//                         (tagId) => {
//                           const tag = tags.find((t) => t.id === tagId);
//                           return tag ? `${tag.name} (${tag.unit})` : tagId;
//                         }
//                       )}
//                       selectedValues={(selectedTagsWithUnits) => {
//                         const selectedTagIds = selectedTagsWithUnits.map(
//                           (nameWithUnit) => {
//                             const baseName = nameWithUnit.split(" (")[0];
//                             const tag = tags.find(
//                               (t) =>
//                                 t.name === baseName &&
//                                 (t.unit === "kWh" || t.unit === "kVAh")
//                             );
//                             return tag ? tag.id : baseName;
//                           }
//                         );
//                         handleInputChange("tagId")(selectedTagIds);
//                       }}
//                       width={210}
//                     />
//                   </>
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--narrow field-label--${themechange}`}>
//                   Tariff ID
//                   <span className="required-asterisk">*</span>
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.tariffId)
//                 ) : (
//                   <CustomSelectMenuItem
//                     id={"tariff-id-input"}
//                     onChange={(e) => handleInputChange("tariffId")(e)}
//                     options={tariffs}
//                     defaultValue={customerInfo.data.tariffId || ""}
//                     disabled={isUpdateMode}
//                     width={210}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--date field-label--${themechange}`}>
//                   Removal Date
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.removalDate)
//                 ) : (
//                   <CustomDatePicker
//                     name={"removalDate"}
//                     onChange={(date) => {
//                       const event = { target: { value: date } };
//                       handleInputChange("removalDate")(event);
//                     }}
//                     views={["day", "month", "year"]}
//                     width={224}
//                     defaultValue={
//                       customerInfo.data.removalDate
//                         ? dayjs(customerInfo.data.removalDate)
//                         : null
//                     }
//                     placeholder={"DD/MM/YYYY"}
//                     disabled={isViewMode}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={4}>
//               <Box className="config--form--box">
//                 <Typography className={`field-label field-label--${themechange}`}>
//                   Reason For Removal
//                 </Typography>
//                 {isViewMode ? (
//                   renderFieldValue(customerInfo.data.reasonForRemoval)
//                 ) : (
//                   <CustomTextField
//                     id={"reason-for-removal-input"}
//                     onChange={handleInputChange("reasonForRemoval")}
//                     defaultValue={customerInfo.data.reasonForRemoval}
//                     disabled={isViewMode}
//                     maxLength={10}
//                     width={450}
//                   />
//                 )}
//               </Box>
//             </Grid>

//             {customerInfo.data.previousMeterIds.map((meterId, index) => (
//               <Grid item xs={12} md={4} key={index}>
//                 <Box className="config--form--box">
//                   <Typography className={`field-label field-label--${themechange}`}>
//                     Previous MeterId
//                   </Typography>
//                   {isViewMode ? (
//                     renderFieldValue(customerInfo.data.previousMeterId)
//                   ) : (
//                     <CustomTextField
//                       id="previous-meterId-input"
//                       onChange={handleInputChange("previousMeterId")}
//                       defaultValue={
//                         customerInfo.data.previousMeterIds?.length > 0
//                           ? customerInfo.data.previousMeterIds.slice(-1)[0]
//                               .meterId
//                           : ""
//                       }
//                       disabled={isViewMode}
//                       maxLength={50}
//                       width={500}
//                     />
//                   )}
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Box>

//         <Box className="form-actions">
//           {isViewMode ? (
//             <CustomButton
//               buttonText={"Close"}
//               onClick={() => {
//                 setOpenForm(false);
//                 setCustomerInfo(initialCustomerInfo);
//                 setFormMode("add");
//               }}
//             />
//           ) : (
//             <>
//               <CustomButton
//                 buttonText={isLoading ? "Saving..." : "Save Customer"}
//                 onClick={handleSaveOrUpdate}
//                 disabled={isLoading}
//               />
//               <CustomButton
//                 buttonText={"Cancel"}
//                 onClick={() => {
//                   setOpenForm(false);
//                   setCustomerInfo(initialCustomerInfo);
//                   setFormMode("add");
//                 }}
//                 disabled={isLoading}
//               />
//             </>
//           )}
//         </Box>
//       </Box>
//     );
//   };

//   return (
//     <Box className={`dashboard-container dashboard-container--${themechange}`}>
//       {openForm ? (
//         renderAddCustomerForm()
//       ) : (
//         <>
//           {saveStatus !== 0 ? (
//             <CustomToast
//               openToast={saveStatus !== 0}
//               type={saveStatus === 1 ? "Success" : "Error"}
//               toastText={
//                 saveStatus === 1
//                   ? "Customer Saved Successfully!"
//                   : "Save Failed"
//               }
//               onClose={handleToastClose}
//               autoHideDuration={10000}
//             />
//           ) : (
//             <></>
//           )}
//           {deleteSuccess !== 0 ? (
//             <CustomToast
//               openToast={deleteSuccess !== 0}
//               type={deleteSuccess === 1 ? "Success" : "Error"}
//               toastText={
//                 deleteSuccess === 1
//                   ? "Customer Deleted Successfully!"
//                   : "Delete Failed"
//               }
//               onClose={handleDeleteToastClose}
//               autoHideDuration={10000}
//             />
//           ) : (
//             <></>
//           )}
//           <CustomerMetrics customers={customers} />

//           {/* <Box className="header-container">
//             <Box></Box>
//             <Box className="search-actions-container">
//               <TextField
//                 size="small"
//                 placeholder="Search by Name"
//                 variant="standard"
//                 value={search.searchText}
//                 onChange={(e) =>
//                   setSearch({ ...search, searchText: e.target.value })
//                 }
//                 onKeyPress={handleKeyPress}
//                 InputProps={{
//                   endAdornment: search.searchText ? (
//                     <InputAdornment position="end">
//                       <IconButton
//                         edge="end"
//                         onClick={handleSearchCancel}
//                         size="small"
//                       >
//                         <ClearIcon fontSize="small" />
//                       </IconButton>
//                     </InputAdornment>
//                   ) : null,
//                 }}
//                 className={`search-field search-field--${themechange}`}
//               />
//               <CustomButton
//                 buttonText={"+Add Customer"}
//                 onClick={() => setOpenForm(true)}
//               />
//             </Box>
//           </Box> */}
//           <Box className="header-container">
//   <Box></Box>
//   <Box className="search-actions-container">
//     <TextField
//       size="small"
//       placeholder="Search by Name"
//       variant="standard"
//       value={search.searchText}
//       onChange={(e) =>
//         setSearch({ ...search, searchText: e.target.value })
//       }
//       onKeyPress={handleKeyPress}
//       InputProps={{
//         endAdornment: search.searchText ? (
//           <InputAdornment position="end">
//             <IconButton
//               edge="end"
//               onClick={handleSearchCancel}
//               size="small"
//             >
//               <ClearIcon fontSize="small" />
//             </IconButton>
//           </InputAdornment>
//         ) : null,
//       }}
//       className={`search-field search-field--${themechange}`}
//     />
//    <IconButton
//   onClick={handleSearchClick}
//   style={{
//     fontSize: '12px',
//     width: "30px",
//     minWidth: "30px",
//     fontWeight: 400,
//     color: 'var(--Searchtext_muted)',
//     fontFamily: 'Roboto',
//     textAlign: 'left',
//     justifySelf: "right",
//     cursor: 'pointer',
//     textTransform: 'none',
//     marginLeft: "0px",
//     padding: 0
//   }}
// >
//   <SearchIcon
//     color={theme === 'light' ? '#3C3C3C' : '#C1C1C1'}
//     width={30}
//     height={30}
//   />
// </IconButton>
//     <CustomButton
//       buttonText={"+Add Customer"}
//       onClick={() => setOpenForm(true)}
//     />
//   </Box>
// </Box>

//           <TableContainer
//             component={Paper}
//             className="table-container"
//             elevation={0}
//           >
//             <Table stickyHeader className="customers-table" size="small">
//               <TableHead>
//                 <TableRow className="table-header-row">
//                   <TableCell
//                     className="table-header-cell"
//                     sx={{
//                       fontSize:
//                         props.widgetprop.props.extended.tablehead.fontsize,
//                       fontWeight:
//                         props.widgetprop.props.extended.tablehead.fontweight,
//                     }}
//                   >
//                     Customer Name
//                   </TableCell>
//                   <TableCell
//                     className="table-header-cell"
//                     sx={{
//                       fontSize:
//                         props.widgetprop.props.extended.tablehead.fontsize,
//                       fontWeight:
//                         props.widgetprop.props.extended.tablehead.fontweight,
//                     }}
//                   >
//                     Sanction Load
//                   </TableCell>
//                   <TableCell
//                     className="table-header-cell"
//                     sx={{
//                       fontSize:
//                         props.widgetprop.props.extended.tablehead.fontsize,
//                       fontWeight:
//                         props.widgetprop.props.extended.tablehead.fontweight,
//                     }}
//                   >
//                     Billing Cycle
//                   </TableCell>
//                   <TableCell
//                     className="table-header-cell"
//                     sx={{
//                       fontSize:
//                         props.widgetprop.props.extended.tablehead.fontsize,
//                       fontWeight:
//                         props.widgetprop.props.extended.tablehead.fontweight,
//                     }}
//                   >
//                     Status
//                   </TableCell>
//                   <TableCell
//                     className="table-header-cell"
//                     sx={{
//                       fontSize:
//                         props.widgetprop.props.extended.tablehead.fontsize,
//                       fontWeight:
//                         props.widgetprop.props.extended.tablehead.fontweight,
//                     }}
//                   >
//                     Actions
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {displayCustomers.map((customer) => (
//                   <TableRow
//                     key={customer.id}
//                     className="table-body-row"
//                   >
//                     <TableCell
//                       component="th"
//                       scope="row"
//                       className="table-body-cell"
//                       sx={{
//                         fontSize:
//                           props.widgetprop.props.extended.tablerows.fontsize,
//                         fontWeight:
//                           props.widgetprop.props.extended.tablerows.fontweight,
//                       }}
//                     >
//                       {formatFullName(customer)}
//                     </TableCell>
//                     <TableCell
//                       component="th"
//                       scope="row"
//                       className="table-body-cell"
//                       sx={{
//                         fontSize:
//                           props.widgetprop.props.extended.tablerows.fontsize,
//                         fontWeight:
//                           props.widgetprop.props.extended.tablerows.fontweight,
//                       }}
//                     >
//                       {customer.data.sanctionLoad}
//                     </TableCell>
//                     <TableCell
//                       component="th"
//                       scope="row"
//                       className="table-body-cell"
//                       sx={{
//                         fontSize:
//                           props.widgetprop.props.extended.tablerows.fontsize,
//                         fontWeight:
//                           props.widgetprop.props.extended.tablerows.fontweight,
//                       }}
//                     >
//                       {customer.data.billingCycle}
//                     </TableCell>
//                     <TableCell
//                       component="th"
//                       scope="row"
//                       className={`table-body-cell status-cell status-cell--${customer.data.status?.toLowerCase()}`}
//                       sx={{
//                         fontSize:
//                           props.widgetprop.props.extended.tablerows.fontsize,
//                         fontWeight:
//                           props.widgetprop.props.extended.tablerows.fontweight,
//                       }}
//                     >
//                       {customer.data.accountStatus}
//                     </TableCell>
//                     <TableCell
//                       component="th"
//                       scope="row"
//                       className="table-body-cell"
//                       sx={{
//                         fontSize:
//                           props.widgetprop.props.extended.tablerows.fontsize,
//                         fontWeight:
//                           props.widgetprop.props.extended.tablerows.fontweight,
//                       }}
//                     >
//                       <CustomerActions
//                         customer={customer}
//                         setCustomers={setCustomers}
//                         setOpenForm={setOpenForm}
//                         setCustomerInfo={setCustomerInfo}
//                         setFormMode={setFormMode}
//                         setDeleteSuccess={setDeleteSuccess}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </>
//       )}
//     </Box>
//   );
// }
import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
  TextField,
  Divider,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import {
  getAllCustomers,
  createCustomer,
  createBill,
  updateCustomer,
  deleteCustomer,
  getCustomerMetrics,
  getMeterDevices,
  getTagsForDevices,
  getAllTariffs,
  getOneDayEnergySum,
} from "../../../Restclient/datacollection";
import { ThemeContext } from "../../Homepage";
import CustomButton from "../../CommonComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomMultiSelect from "../../CommonComponents/CustomMultiSelect";
import CustomActionButton from "../../CommonComponents/CustomActionButton";
import CustomTextField from "../../CommonComponents/CustomTextField";
import CustomDropDown from "../../CommonComponents/CustomDropDown";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker";
import CustomSelectMenuItem from "../../CommonComponents/CustomSelectMenuItem";
import CustomDialogBox from "../../CommonComponents/CustomDialogBox";
import dayjs from "dayjs";
import CustomToast from "../../CommonComponents/CustomToast";
import "../../../cssfiles/billing.css";
import SearchIcon from "../../../images/LK_Search";

// Validation utility functions
const validatePhone = (phone) => {
  if (!phone) return { isValid: false, message: "Phone number is required" };
  const phoneRegex = /^[0-9]{12}$/;
  if (!phoneRegex.test(phone)) {
    return {
      isValid: false,
      message: "Phone number must be exactly 12 digits",
    };
  }
  return { isValid: true, message: "" };
};

const validateEmail = (email) => {
  if (!email) return { isValid: false, message: "Email is required" };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, message: "Please enter a valid email address" };
  }
  return { isValid: true, message: "" };
};

const validatePostalCode = (postalCode) => {
  if (!postalCode)
    return { isValid: false, message: "Postal code is required" };
  const postalRegex = /^[0-9]{6}$/;
  if (!postalRegex.test(postalCode)) {
    return { isValid: false, message: "Postal code must be exactly 6 digits" };
  }
  return { isValid: true, message: "" };
};

const sanitizeInput = (value, maxLength, allowedPattern) => {
  if (typeof value !== "string") return value;
  // Remove HTML tags
  let sanitized = value.replace(/<[^>]*>/g, "");
  // Apply character whitelist if provided
  if (allowedPattern) {
    sanitized = sanitized.replace(allowedPattern, "");
  }
  sanitized = sanitized.trim();
  if (maxLength) {
    sanitized = sanitized.slice(0, maxLength);
  }
  return sanitized;
};

// Per-field character restrictions (regex removes disallowed chars)
const FIELD_PATTERNS = {
  // Names: letters, spaces, hyphens, apostrophes
  firstName: /[^a-zA-Z\s'-]/g,
  middleName: /[^a-zA-Z\s'-]/g,
  lastName: /[^a-zA-Z\s'-]/g,
  // Phone / postal: digits only
  phone: /[^0-9]/g,
  postalCode: /[^0-9]/g,
  // Address: alphanumeric, spaces, common punctuation
  addressLine1: /[^a-zA-Z0-9\s,.\/\-#]/g,
  addressLine2: /[^a-zA-Z0-9\s,.\/\-#]/g,
  // City/state/country: letters and spaces only
  city: /[^a-zA-Z\s]/g,
  state: /[^a-zA-Z\s]/g,
  country: /[^a-zA-Z\s]/g,
  // Sanction load: numbers and one decimal point
  sanctionLoad: /[^0-9.]/g,
  // Pole number: alphanumeric and hyphens
  poleNo: /[^a-zA-Z0-9\-]/g,
};

const CustomerActions = ({
  customer,
  setCustomers,
  setCustomerInfo,
  setOpenForm,
  setFormMode,
  setDeleteSuccess,
}) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleViewClick = () => {
    if (!customer || !customer.data || !customer.data.customerId) {
      alert("Cannot view customer - missing data");
      return;
    }

    const customerToView = {
      id: customer.data.customerId,
      data: {
        ...customer.data,
        prepaid: customer.data.prepaid || "",
        billingCycle: customer.data.billingCycle || "",
        billingCycleStart: customer.data.billingCycleStart || "",
        billingCycleEnd: customer.data.billingCycleEnd || "",
        tariffId: customer.data.tariffId || "",
        previousMeterId: customer.data.previousMeterId || "",
        customerType: customer.data.customerType || "",
      },
    };

    setCustomerInfo(customerToView);
    setFormMode("view");
    setOpenForm(true);
  };

  const handleUpdateClick = () => {
    if (!customer || !customer.data || !customer.data.customerId) {
      alert("Cannot update customer - missing data");
      return;
    }

    const customerToUpdate = {
      id: customer.data.customerId,
      data: {
        customerId: customer.data.customerId,
        deviceId: customer.data.deviceId,
        tagId: customer.data.tagId || [],
        firstName: customer.data.firstName || "",
        middleName: customer.data.middleName || "",
        lastName: customer.data.lastName || "",
        email: customer.data.email || "",
        phone: customer.data.phone || "",
        addressLine1: customer.data.addressLine1 || "",
        addressLine2: customer.data.addressLine2 || "",
        city: customer.data.city || "",
        state: customer.data.state || "",
        country: customer.data.country || "",
        postalCode: customer.data.postalCode || "",
        poleNo: customer.data.poleNo || "",
        isActive: customer.data.isActive ?? true,
        customerType: customer.data.customerType || "",
        prepaid: customer.data.prepaid || "",
        accountCreationDate: customer.data.accountCreationDate || "",
        initialMeterReading: customer.data.initialMeterReading || "",
        finalMeterReading: customer.data.finalMeterReading || "",
        billingCycle: customer.data.billingCycle || "",
        billingCycleStart: customer.data.billingCycleStart || "",
        billingCycleEnd: customer.data.billingCycleEnd || "",
        previousMeterIds: Array.isArray(customer.data.previousMeterIds)
          ? customer.data.previousMeterIds
          : [""],
        previousMeterId: customer.data.previousMeterId || "",
        sanctionLoad: customer.data.sanctionLoad || "",
        tariffId: customer.data.tariffId || "",
        accountStatus: customer.data.accountStatus || "",
      },
    };

    setCustomerInfo(customerToUpdate);
    setFormMode("update");
    setOpenForm(true);
  };

  const handleDeleteClick = () => {
    setOpenConfirm(true);
  };

  const handleDelete = () => {
    const customerId = customer.data.customerId;

    setLoading(true);
    deleteCustomer(customerId, (response) => {
      setLoading(false);
      if (response.success) {
        setCustomers((prev) =>
          prev.filter((c) => c.data.customerId !== customerId),
        );
        setOpenConfirm(false);
        setDeleteSuccess(1);
      } else {
        setDeleteSuccess(2);
      }
    });
  };

  return (
    <>
      <Box className="customer-actions-container">
        <CustomActionButton buttonText={"View"} onClick={handleViewClick} />
        <CustomActionButton buttonText={"Delete"} onClick={handleDeleteClick} />
        <CustomActionButton buttonText={"Update"} onClick={handleUpdateClick} />
      </Box>
      <CustomDialogBox
        dialogTitle={"Delete Confirmation"}
        dialogText={`Are you sure you want to delete customer ${customer.data.firstName} ${customer.data.lastName}? This action cannot be undone.`}
        openDialog={openConfirm}
        handleCloseDialog={() => setOpenConfirm(false)}
        handleConfirmDialog={handleDelete}
        confirmText={"Delete"}
        cancelText={"Cancel"}
        type={"Warning"}
        loading={loading}
      />
    </>
  );
};

const CustomerMetrics = () => {
  const [metrics, setMetrics] = useState({
    totalCustomers: 0,
    activeCustomers: 0,
    inactiveCustomers: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchMetrics = () => {
      setIsLoading(true);
      getCustomerMetrics((response) => {
        if (response.state === true && response.metrics) {
          setMetrics({
            totalCustomers: response.metrics.totalCustomers,
            activeCustomers: response.metrics.activeCustomers,
            inactiveCustomers: response.metrics.inactiveCustomers,
          });
        }
        setIsLoading(false);
      });
    };

    fetchMetrics();
    const interval = setInterval(fetchMetrics, 60000);
    return () => clearInterval(interval);
  }, []);

  const metricsData = [
    {
      label: "Total Customers",
      value: metrics.totalCustomers,
      color: "var(--PrimaryText)",
    },
    {
      label: "Active Customers",
      value: metrics.activeCustomers,
      color: "var(--GreenBaseColor)",
    },
    {
      label: "Inactive Customers",
      value: metrics.inactiveCustomers,
      color: "var(--GreyBaseColor)",
    },
  ];

  return (
    <div className="metrics-card card2">
      <div className="metrics-container">
        {metricsData.map((metric, index) => (
          <React.Fragment key={index}>
            <div className="metric-item cardtext">
              <div>
                <Typography className="metric-label">{metric.label}</Typography>
              </div>
              <div>
                <Typography
                  className="metric-value"
                  style={{ color: metric.color }}
                >
                  {metric.value}
                </Typography>
              </div>
            </div>
            {index < metricsData.length - 1 && (
              <Divider
                orientation="vertical"
                variant="middle"
                className="metric-divider"
                flexItem
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default function UtilityCustomerDashboard(props) {
  const dispatch = useDispatch();
  const themechange = useSelector((state) => state.themedata.theme);
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [required, setRequired] = useState(0);
  const [validationError, setValidationError] = useState("");
  const [search, setSearch] = useState({ searchText: "", filterSelected: "" });
  const [isSearching, setIsSearching] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const { theme } = useContext(ThemeContext);
  const [tariffs, setTariffs] = useState([]);
  const [formMode, setFormMode] = useState("add");
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const [devices, setDevices] = useState([]);
  const [tags, setTags] = useState({});
  const [saveStatus, setSaveStatus] = React.useState(0);
  const [deleteSuccess, setDeleteSuccess] = React.useState(0);

  const initialCustomerInfo = {
    id: "",
    data: {
      customerId: "",
      deviceId: "",
      tagId: [""],
      firstName: "",
      middleName: "",
      lastName: "",
      customerType: "",
      email: "",
      phone: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
      poleNo: "",
      isActive: true,
      prepaid: "",
      sanctionLoad: "",
      accountCreationDate: "",
      billingCycle: "",
      billingCycleStart: "",
      billingCycleEnd: "",
      removalDate: "",
      reasonForRemoval: "",
      previousMeterId: "",
      previousMeterIds: [""],
      tariffId: "",
      initialMeterReading: "",
      finalMeterReading: "",
      accountStatus: "",
    },
  };
  const [customerInfo, setCustomerInfo] = useState(initialCustomerInfo);

  const formatFullName = (customer) => {
    const firstName = customer.data.firstName || "";
    const middleName = customer.data.middleName || "";
    const lastName = customer.data.lastName || "";

    return [firstName, middleName, lastName].filter(Boolean).join(" ") || "-";
  };

  const fetchCustomers = () => {
    setIsLoading(true);
    getAllCustomers((response) => {
      if (response && response.state && response.customers) {
        const formattedCustomers = response.customers.map((customer) => ({
          id: customer.data.customerId,
          data: {
            ...customer.data,
            prepaid: customer.data.prepaid || "",
            accountCreationDate: customer.data.accountCreationDate || "",
            billingCycle: customer.data.billingCycle || "",
            billingCycleStart: customer.data.billingCycleStart || "",
            billingCycleEnd: customer.data.billingCycleEnd || "",
            deviceId: customer.data.deviceId || "",
            tagId: customer.data.tagId || [],
            previousMeterIds: customer.data.previousMeterIds || [""],
            tariffId: customer.data.tariffId || "",
            customerType: customer.data.customerType || "",
            status: customer.data.accountStatus || "",
          },
        }));
        setCustomers(formattedCustomers);
      } else {
        setError("No customers found");
        setCustomers([]);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (!openForm) {
      fetchCustomers();
    }
  }, [openForm]);

  // Re-fetch devices, tags and tariffs when update/view form opens to ensure dropdown options are populated
  useEffect(() => {
    if (openForm && (formMode === "update" || formMode === "view")) {
      getMeterDevices((devicesResponse) => {
        const fetchedDevices = devicesResponse?.devices || [];
        setDevices(fetchedDevices);

        const deviceIds = fetchedDevices.map((d) => d.id);
        if (deviceIds.length > 0) {
          getTagsForDevices(deviceIds, (tagsResponse) => {
            if (tagsResponse?.state && Array.isArray(tagsResponse.tags)) {
              const tagsByDevice = {};
              tagsResponse.tags.forEach((tag) => {
                if (!tagsByDevice[tag.deviceId])
                  tagsByDevice[tag.deviceId] = [];
                tagsByDevice[tag.deviceId].push(tag);
              });
              setTags(tagsByDevice);
            }
          });
        }
      });

      getAllTariffs((tariffsResponse) => {
        if (tariffsResponse?.state) {
          setTariffs(tariffsResponse.tariffs);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openForm, formMode]);

  useEffect(() => {
    const fetchDevicesTariffsAndTags = () => {
      getMeterDevices((devicesResponse) => {
        const fetchedDevices = devicesResponse?.devices || [];
        setDevices(fetchedDevices);

        if (fetchedDevices.length > 0) {
          const deviceIds = fetchedDevices.map((device) => device.id);
          getTagsForDevices(deviceIds, (tagsResponse) => {
            if (tagsResponse?.state && Array.isArray(tagsResponse.tags)) {
              const tagsByDevice = {};
              tagsResponse.tags.forEach((tag) => {
                if (!tagsByDevice[tag.deviceId]) {
                  tagsByDevice[tag.deviceId] = [];
                }
                tagsByDevice[tag.deviceId].push(tag);
              });
              setTags(tagsByDevice);
            } else {
              setTags({});
            }
          });
        } else {
          setTags({});
        }

        getAllTariffs((tariffsResponse) => {
          if (tariffsResponse?.state) {
            setTariffs(tariffsResponse.tariffs);
          } else {
            setTariffs([]);
          }
        });
      });
    };

    fetchDevicesTariffsAndTags();
  }, [userdetails]);

  const handleInputChange = (field) => (event) => {
    const value = event?.target?.value ?? event;

    // Sanitize input with field-specific character restriction
    const sanitizedValue =
      typeof value === "string"
        ? sanitizeInput(value, 100, FIELD_PATTERNS[field] || null)
        : value;

    if (["firstName", "middleName", "lastName"].includes(field)) {
      const updatedInfo = { ...customerInfo };
      updatedInfo.data[field] = sanitizedValue;

      const fullName = [
        updatedInfo.data.firstName,
        updatedInfo.data.middleName,
        updatedInfo.data.lastName,
      ]
        .filter(Boolean)
        .join(" ");

      updatedInfo.data.name = fullName;
      setCustomerInfo(updatedInfo);
    } else {
      setCustomerInfo((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          [field]: sanitizedValue,
        },
      }));
    }
  };

  const validateForm = () => {
    let isValid = true;
    const missingFields = [];

    // Validate mandatory fields (excluding billingCycleStart as it may be set through date picker)
    const mandatoryFields = {
      firstName: "First Name",
      lastName: "Last Name",
      phone: "Phone",
      email: "Email",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      city: "City",
      state: "State",
      country: "Country",
      postalCode: "Postal Code",
      customerType: "Customer Type",
      sanctionLoad: "Sanction Load",
      accountStatus: "Account Status",
      deviceId: "Meter ID",
      tariffId: "Tariff ID",
    };

    // Check for empty mandatory fields
    for (const [key, label] of Object.entries(mandatoryFields)) {
      const value = customerInfo.data[key];
      if (!value || (typeof value === "string" && value.trim() === "")) {
        isValid = false;
        missingFields.push(label);
        console.log(`Missing field: ${label}, value:`, value);
      }
    }

    // Validate phone number format
    if (customerInfo.data.phone) {
      const phoneValidation = validatePhone(customerInfo.data.phone);
      if (!phoneValidation.isValid) {
        isValid = false;
        missingFields.push("Phone (invalid format)");
        console.log("Phone validation failed:", customerInfo.data.phone);
      }
    }

    // Validate email format
    if (customerInfo.data.email) {
      const emailValidation = validateEmail(customerInfo.data.email);
      if (!emailValidation.isValid) {
        isValid = false;
        missingFields.push("Email (invalid format)");
        console.log("Email validation failed:", customerInfo.data.email);
      }
    }

    // Validate postal code format
    if (customerInfo.data.postalCode) {
      const postalValidation = validatePostalCode(customerInfo.data.postalCode);
      if (!postalValidation.isValid) {
        isValid = false;
        missingFields.push("Postal Code (must be exactly 6 digits)");
        console.log(
          "Postal code validation failed:",
          customerInfo.data.postalCode,
        );
      }
    }

    // Validate Sanction Load (must be a positive number)
    if (
      customerInfo.data.sanctionLoad &&
      !missingFields.includes("Sanction Load")
    ) {
      const sanctionNum = parseFloat(customerInfo.data.sanctionLoad);
      if (isNaN(sanctionNum) || sanctionNum <= 0) {
        isValid = false;
        missingFields.push("Sanction Load (must be a positive number)");
      }
    }

    if (!isValid) {
      setValidationError(`Please fill in: ${missingFields.join(", ")}`);
      setRequired(1);
    }

    return isValid;
  };

  const handleSaveOrUpdate = () => {
    // Clear previous errors
    setValidationError("");

    if (!customerInfo || !customerInfo.data) {
      setValidationError("Customer information is missing");
      setRequired(1);
      return;
    }

    // Validate form
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    if (customerInfo.id || customerInfo.data.customerId) {
      const customerId = customerInfo.data.customerId || customerInfo.id;

      const updatePayload = { ...customerInfo.data };

      if (updatePayload.removalDate && updatePayload.reasonForRemoval) {
        updatePayload.previousMeterIds = [
          ...(customerInfo.data.previousMeterIds || []),
          {
            meterId: customerInfo.data.deviceId,
            tagId: customerInfo.data.tagId,
            removalDate: updatePayload.removalDate,
            reasonForRemoval: updatePayload.reasonForRemoval,
            initialReading: customerInfo.data.initialMeterReading,
            finalReading: "TBD",
            unitsConsumed: "TBD",
          },
        ];

        if (!customerInfo.data.deviceId) {
          updatePayload.deviceId = "";
        }
        if (!customerInfo.data.tagId || customerInfo.data.tagId.length === 0) {
          updatePayload.tagId = "";
        }
      }

      updateCustomer(customerId, updatePayload, (response) => {
        if (response.success) {
          setCustomers((prev) =>
            prev.map((c) =>
              c.data.customerId === customerId
                ? { id: customerId, data: response.customer }
                : c,
            ),
          );

          setSaveStatus(1);

          setTimeout(() => {
            setOpenForm(false);
            setCustomerInfo(initialCustomerInfo);
            setFormMode("add");
            setTimeout(() => setSaveStatus(0), 5000);
          }, 5000);
        } else {
          setSaveStatus(2);
          setValidationError(response.error || "Failed to update customer");
          setRequired(1);
          setTimeout(() => setSaveStatus(0), 5000);
        }

        setIsLoading(false);
      });

      return;
    }

    createCustomer(
      {
        type: "customer",
        deviceId: customerInfo.data.deviceId || "",
        tagId: Array.isArray(customerInfo.data.tagId)
          ? customerInfo.data.tagId
          : [],
        firstName: customerInfo.data.firstName?.trim(),
        middleName: customerInfo.data.middleName?.trim() || "",
        lastName: customerInfo.data.lastName?.trim(),
        email: customerInfo.data.email?.trim() || "",
        phone: customerInfo.data.phone?.trim(),
        customerType: customerInfo.data.customerType?.trim() || "",
        isActive: true,
        addressLine1: customerInfo.data.addressLine1?.trim() || "",
        addressLine2: customerInfo.data.addressLine2?.trim() || "",
        city: customerInfo.data.city?.trim(),
        state: customerInfo.data.state?.trim(),
        country: customerInfo.data.country?.trim(),
        postalCode: customerInfo.data.postalCode?.trim() || "",
        poleNo: customerInfo.data.poleNo?.trim() || "",
        prepaid: customerInfo.data.prepaid?.trim() || "No",
        accountCreationDate:
          customerInfo.data.accountCreationDate || new Date().toISOString(),
        billingCycle: customerInfo.data.billingCycle?.trim() || "Monthly",
        billingCycleStart: customerInfo.data.billingCycleStart || "",
        billingCycleEnd: customerInfo.data.billingCycleEnd || "",
        initialMeterReading: customerInfo.data.initialMeterReading || "",
        finalMeterReading: customerInfo.data.finalMeterReading || "",
        removalDate: customerInfo.data.removalDate || "",
        reasonForRemoval: customerInfo.data.reasonForRemoval?.trim() || "",
        previousMeterIds: Array.isArray(customerInfo.data.previousMeterIds)
          ? customerInfo.data.previousMeterIds.filter((item) =>
              typeof item === "string" ? item.trim() !== "" : true,
            )
          : [],
        sanctionLoad: customerInfo.data.sanctionLoad?.trim() || "",
        tariffId: customerInfo.data.tariffId?.trim(),
        accountStatus: customerInfo.data.accountStatus?.trim() || "Active",
        userEmail: userdetails.Email || "",
      },
      (response) => {
        if (response.success) {
          const tagId = customerInfo.data.tagId;
          const customerId =
            response.customer.data?.customerId || response.customer.id;
          const today = new Date().toISOString().split("T")[0];

          if (!tagId || (Array.isArray(tagId) && tagId.length === 0)) {
            setCustomers((prev) => [...prev, response.customer]);
            setSaveStatus(1);

            setTimeout(() => {
              setOpenForm(false);
              setCustomerInfo(initialCustomerInfo);
              setFormMode("add");
              setTimeout(() => setSaveStatus(0), 5000);
            }, 5000);

            setIsLoading(false);
            return;
          }

          const tagIds = Array.isArray(tagId) ? tagId : [tagId];

          const energyPromises = tagIds.map(
            (singleTagId) =>
              new Promise((resolve) => {
                getOneDayEnergySum(singleTagId, today, (energyResponse) => {
                  resolve(
                    energyResponse.success ? energyResponse.energySum || 0 : 0,
                  );
                });
              }),
          );

          Promise.all(energyPromises).then((energySums) => {
            const totalEnergySum = energySums.reduce(
              (sum, current) => sum + current,
              0,
            );

            if (!customerId) {
              console.error("Customer ID is missing for bill creation");
              setCustomers((prev) => [...prev, response.customer]);
              setSaveStatus(1);
              setTimeout(() => {
                setOpenForm(false);
                setCustomerInfo(initialCustomerInfo);
                setFormMode("add");
                setTimeout(() => setSaveStatus(0), 5000);
              }, 5000);
              setIsLoading(false);
              return;
            }

            const billPayload = {
              customerId: customerId,
              tagId: tagIds,
              energySum: totalEnergySum,
              date: today,
            };

            createBill(billPayload, (billResponse) => {
              if (!billResponse.success) {
                console.error("Bill creation failed but customer was created");
              }
              setCustomers((prev) => [...prev, response.customer]);
              setSaveStatus(1);
              setTimeout(() => {
                setOpenForm(false);
                setCustomerInfo(initialCustomerInfo);
                setFormMode("add");
                setTimeout(() => setSaveStatus(0), 5000);
              }, 5000);
              setIsLoading(false);
            });
          });
        } else {
          setValidationError(response.error || "Failed to create customer");
          setSaveStatus(2);
          setRequired(1);
          setIsLoading(false);
        }
      },
    );
  };

  const handleToastClose = () => {
    setSaveStatus(0);
  };

  const handleDeleteToastClose = () => {
    setDeleteSuccess(0);
  };

  const handleSearchClick = () => {
    setIsLoading(true);
    getAllCustomers((response) => {
      if (response && response.customers) {
        const filteredCustomers = response.customers.filter((customer) => {
          const fullName = [
            customer.data.firstName,
            customer.data.middleName,
            customer.data.lastName,
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();
          const searchLower = search.searchText.toLowerCase();
          if (!searchLower) return true;
          return (
            fullName.includes(searchLower) ||
            customer.data.firstName.toLowerCase().includes(searchLower) ||
            customer.data.lastName.toLowerCase().includes(searchLower) ||
            (customer.data.middleName &&
              customer.data.middleName.toLowerCase().includes(searchLower))
          );
        });

        setSearchList(filteredCustomers);
        setIsSearching(true);
      }
      setIsLoading(false);
    });
  };

  const handleSearchCancel = () => {
    setSearch({ searchText: "", filterSelected: "" });
    setSearchList([]);
    setIsSearching(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearchClick();
    }
  };

  const availableDevices = devices.filter((device) => {
    return !customerInfo.data.previousMeterIds.some(
      (prev) => prev.meterId === device.id,
    );
  });

  const displayCustomers = isSearching ? searchList : customers;

  const renderFieldValue = (value) => {
    return (
      <Box className={`field-value field-value--${themechange}`}>
        {value || "-"}
      </Box>
    );
  };

  const renderAddCustomerForm = () => {
    if (!customerInfo) return null;

    const isViewMode = formMode === "view";
    const isUpdateMode = formMode === "update" && customerInfo.id;

    const selectedDeviceId = customerInfo.data.deviceId;
    console.log("[renderAddCustomerForm] selectedDeviceId:", selectedDeviceId);
    console.log("[renderAddCustomerForm] tags object keys:", Object.keys(tags));
    console.log(
      "[renderAddCustomerForm] tags for device:",
      tags[selectedDeviceId],
    );

    const tagsForSelectedDevice = (tags[selectedDeviceId] || []).filter(
      (tag) => tag.unit === "kWh" || tag.unit === "kVAh",
    );

    return (
      <Box className={`form-container form-container--${themechange}`}>
        <Typography
          variant="h5"
          className={`form-title form-title--${themechange}`}
        >
          {isViewMode
            ? "View Customer"
            : customerInfo.id
              ? "Update Customer"
              : "Add New Customer"}
        </Typography>

        <Box className="form-section">
          <Typography variant="h6" className="section-title">
            Personal Information
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  First Name
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.firstName)
                ) : (
                  <CustomTextField
                    id={"first-name-input"}
                    onChange={handleInputChange("firstName")}
                    defaultValue={customerInfo.data.firstName}
                    disabled={isViewMode}
                    maxLength={50}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Middle Name
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.middleName)
                ) : (
                  <CustomTextField
                    id={"middle-name-input"}
                    onChange={handleInputChange("middleName")}
                    defaultValue={customerInfo.data.middleName}
                    disabled={isViewMode}
                    maxLength={50}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Last Name
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.lastName)
                ) : (
                  <CustomTextField
                    id={"last-name-input"}
                    onChange={handleInputChange("lastName")}
                    defaultValue={customerInfo.data.lastName}
                    disabled={isViewMode}
                    maxLength={50}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Email
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.email)
                ) : (
                  <CustomTextField
                    id={"email-input"}
                    onChange={handleInputChange("email")}
                    defaultValue={customerInfo.data.email}
                    disabled={isViewMode}
                    maxLength={100}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Phone
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.phone)
                ) : (
                  <CustomTextField
                    id={"phone-input"}
                    onChange={handleInputChange("phone")}
                    defaultValue={customerInfo.data.phone}
                    disabled={isViewMode}
                    maxLength={12}
                    width={200}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className="form-section">
          <Typography variant="h6" className="section-title">
            Address Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Address Line 1<span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.addressLine1)
                ) : (
                  <CustomTextField
                    id={"address-line1-input"}
                    onChange={handleInputChange("addressLine1")}
                    defaultValue={customerInfo.data.addressLine1}
                    disabled={isViewMode}
                    maxLength={100}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Address Line 2<span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.addressLine2)
                ) : (
                  <CustomTextField
                    id={"address-line2-input"}
                    onChange={handleInputChange("addressLine2")}
                    defaultValue={customerInfo.data.addressLine2}
                    disabled={isViewMode}
                    maxLength={100}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  City
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.city)
                ) : (
                  <CustomTextField
                    id={"city-input"}
                    onChange={handleInputChange("city")}
                    defaultValue={customerInfo.data.city}
                    disabled={isViewMode}
                    maxLength={50}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  State
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.state)
                ) : (
                  <CustomTextField
                    id={"state-input"}
                    onChange={handleInputChange("state")}
                    defaultValue={customerInfo.data.state}
                    disabled={isViewMode}
                    maxLength={50}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Country
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.country)
                ) : (
                  <CustomTextField
                    id={"country-input"}
                    onChange={handleInputChange("country")}
                    defaultValue={customerInfo.data.country}
                    disabled={isViewMode}
                    maxLength={50}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Postal Code
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.postalCode)
                ) : (
                  <CustomTextField
                    id={"postal-code-input"}
                    onChange={handleInputChange("postalCode")}
                    defaultValue={customerInfo.data.postalCode}
                    disabled={isViewMode}
                    maxLength={6}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Pole Number
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.poleNo)
                ) : (
                  <CustomTextField
                    id={"pole-number-input"}
                    onChange={handleInputChange("poleNo")}
                    defaultValue={customerInfo.data.poleNo}
                    disabled={isViewMode}
                    maxLength={50}
                    width={200}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className="form-section">
          <Typography variant="h6" className="section-title">
            Other Account Details
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--narrow field-label--${themechange}`}
                >
                  Customer Type
                  <span className="required-asterisk">*</span>
                </Typography>

                {isViewMode ? (
                  renderFieldValue(customerInfo.data.customerType)
                ) : (
                  <CustomDropDown
                    id={"customer-type-input"}
                    onChange={(e) => handleInputChange("customerType")(e)}
                    options={["Residential", "Commercial", "Industrial"]}
                    disabled={isViewMode}
                    defaultValue={customerInfo.data.customerType || ""}
                    width={210}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Sanction Load
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.sanctionLoad)
                ) : (
                  <CustomTextField
                    id={"sanction-load-input"}
                    onChange={handleInputChange("sanctionLoad")}
                    defaultValue={customerInfo.data.sanctionLoad}
                    disabled={isViewMode}
                    maxLength={10}
                    width={200}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--narrow field-label--${themechange}`}
                >
                  Account Status
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.accountStatus)
                ) : (
                  <CustomDropDown
                    id={"account-status-input"}
                    onChange={(e) => handleInputChange("accountStatus")(e)}
                    options={["Active", "Inactive"]}
                    defaultValue={customerInfo.data.accountStatus || ""}
                    disabled={isViewMode}
                    width={210}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--narrow field-label--${themechange}`}
                >
                  Prepaid
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.prepaid)
                ) : (
                  <CustomDropDown
                    id={"prepaid-input"}
                    onChange={handleInputChange("prepaid")}
                    options={["Yes", "No"]}
                    defaultValue={customerInfo.data.prepaid || "No"}
                    disabled={isViewMode}
                    width={210}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box config--form--box--narrow">
                <Typography
                  className={`field-label field-label--narrow field-label--${themechange}`}
                >
                  Billing Cycle
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.billingCycle)
                ) : (
                  <CustomDropDown
                    id={"billing-Cycle-input"}
                    onChange={(e) => handleInputChange("billingCycle")(e)}
                    options={["Monthly"]}
                    defaultValue={customerInfo.data.billingCycle || "Monthly"}
                    disabled={isViewMode}
                    width={210}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--date field-label--${themechange}`}
                >
                  Billing Cycle Start
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.billingCycleStart)
                ) : (
                  <CustomDatePicker
                    name={"billingCycleStart"}
                    onChange={(date) => {
                      const event = { target: { value: date } };
                      handleInputChange("billingCycleStart")(event);
                    }}
                    views={["day", "month", "year"]}
                    width={224}
                    defaultValue={
                      customerInfo.data.billingCycleStart
                        ? dayjs(customerInfo.data.billingCycleStart)
                        : null
                    }
                    placeholder={"DD/MM/YYYY"}
                    disabled={isViewMode}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--narrow field-label--${themechange}`}
                >
                  Meter ID
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.deviceId)
                ) : (
                  <CustomSelectMenuItem
                    id={"device-id-input"}
                    key={`device-${devices.length}-${customerInfo.data.deviceId}`}
                    onChange={handleInputChange("deviceId")}
                    //options={availableDevices}
                    options={isUpdateMode ? devices : availableDevices}
                    defaultValue={customerInfo.data.deviceId || ""}
                    disabled={isViewMode}
                    width={210}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--narrow field-label--${themechange}`}
                >
                  Tag IDs
                </Typography>
                {isViewMode ? (
                  renderFieldValue(
                    Array.isArray(customerInfo.data.tagId)
                      ? customerInfo.data.tagId.join(", ")
                      : customerInfo.data.tagId,
                  )
                ) : tagsForSelectedDevice.length > 0 ? (
                  <CustomMultiSelect
                    names={tagsForSelectedDevice.map(
                      (tag) => `${tag.name} (${tag.unit})`,
                    )}
                    defaultValue={(customerInfo.data.tagId || []).map(
                      (tagId) => {
                        const tag = tagsForSelectedDevice.find(
                          (t) => t.id === tagId,
                        );
                        return tag ? `${tag.name} (${tag.unit})` : tagId;
                      },
                    )}
                    selectedValues={(selectedTagsWithUnits) => {
                      const selectedTagIds = selectedTagsWithUnits.map(
                        (nameWithUnit) => {
                          const baseName = nameWithUnit.split(" (")[0];
                          const tag = tagsForSelectedDevice.find(
                            (t) => t.name === baseName,
                          );
                          return tag ? tag.id : baseName;
                        },
                      );
                      handleInputChange("tagId")(selectedTagIds);
                    }}
                    width={210}
                  />
                ) : (
                  <Typography
                    variant="body2"
                    sx={{ color: "#999", marginTop: "8px" }}
                  >
                    {selectedDeviceId
                      ? "No kWh/kVAh tags found for this meter."
                      : "Please select a meter first."}
                  </Typography>
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--narrow field-label--${themechange}`}
                >
                  Tariff ID
                  <span className="required-asterisk">*</span>
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.tariffId)
                ) : (
                  <CustomSelectMenuItem
                    id={"tariff-id-input"}
                    key={`tariff-${tariffs.length}-${customerInfo.data.tariffId}`}
                    onChange={(e) => handleInputChange("tariffId")(e)}
                    options={tariffs}
                    defaultValue={customerInfo.data.tariffId || ""}
                    disabled={isViewMode}
                    width={210}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--date field-label--${themechange}`}
                >
                  Removal Date
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.removalDate)
                ) : (
                  <CustomDatePicker
                    name={"removalDate"}
                    onChange={(date) => {
                      const event = { target: { value: date } };
                      handleInputChange("removalDate")(event);
                    }}
                    views={["day", "month", "year"]}
                    width={224}
                    defaultValue={
                      customerInfo.data.removalDate
                        ? dayjs(customerInfo.data.removalDate)
                        : null
                    }
                    placeholder={"DD/MM/YYYY"}
                    disabled={isViewMode}
                  />
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="config--form--box">
                <Typography
                  className={`field-label field-label--${themechange}`}
                >
                  Reason For Removal
                </Typography>
                {isViewMode ? (
                  renderFieldValue(customerInfo.data.reasonForRemoval)
                ) : (
                  <CustomTextField
                    id={"reason-for-removal-input"}
                    onChange={handleInputChange("reasonForRemoval")}
                    defaultValue={customerInfo.data.reasonForRemoval}
                    disabled={isViewMode}
                    maxLength={200}
                    width={450}
                  />
                )}
              </Box>
            </Grid>

            {customerInfo.data.previousMeterIds.map((meterId, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Box className="config--form--box">
                  <Typography
                    className={`field-label field-label--${themechange}`}
                  >
                    Previous MeterId
                  </Typography>
                  {isViewMode ? (
                    renderFieldValue(customerInfo.data.previousMeterId)
                  ) : (
                    <CustomTextField
                      id="previous-meterId-input"
                      onChange={handleInputChange("previousMeterId")}
                      defaultValue={
                        customerInfo.data.previousMeterIds?.length > 0
                          ? customerInfo.data.previousMeterIds.slice(-1)[0]
                              .meterId
                          : ""
                      }
                      disabled={isViewMode}
                      maxLength={50}
                      width={500}
                    />
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box className="form-actions">
          {isViewMode ? (
            <CustomButton
              buttonText={"Close"}
              onClick={() => {
                setOpenForm(false);
                setCustomerInfo(initialCustomerInfo);
                setFormMode("add");
                setValidationError("");
              }}
            />
          ) : (
            <>
              <CustomDialogBox
                dialogTitle={"Validation Error"}
                dialogText={validationError || "Required fields must be filled"}
                openDialog={required === 1}
                handleCloseDialog={() => setRequired(0)}
                handleConfirmDialog={() => setRequired(0)}
                confirmText={"OK"}
                type={"Warning"}
              />
              <CustomButton
                buttonText={isLoading ? "Saving..." : "Save Customer"}
                onClick={handleSaveOrUpdate}
                disabled={isLoading}
              />
              <CustomButton
                buttonText={"Cancel"}
                onClick={() => {
                  setOpenForm(false);
                  setCustomerInfo(initialCustomerInfo);
                  setFormMode("add");
                  setValidationError("");
                }}
                disabled={isLoading}
              />
            </>
          )}
        </Box>
      </Box>
    );
  };

  return (
    <Box className={`dashboard-container dashboard-container--${themechange}`}>
      {openForm ? (
        renderAddCustomerForm()
      ) : (
        <>
          {saveStatus !== 0 && (
            <CustomToast
              openToast={saveStatus !== 0}
              type={saveStatus === 1 ? "Success" : "Error"}
              toastText={
                saveStatus === 1
                  ? "Customer Saved Successfully!"
                  : "Save Failed"
              }
              onClose={handleToastClose}
              autoHideDuration={10000}
            />
          )}
          {deleteSuccess !== 0 && (
            <CustomToast
              openToast={deleteSuccess !== 0}
              type={deleteSuccess === 1 ? "Success" : "Error"}
              toastText={
                deleteSuccess === 1
                  ? "Customer Deleted Successfully!"
                  : "Delete Failed"
              }
              onClose={handleDeleteToastClose}
              autoHideDuration={10000}
            />
          )}
          <CustomerMetrics customers={customers} />

          <Box className="header-container">
            <Box></Box>
            <Box className="search-actions-container">
              <TextField
                size="small"
                placeholder="Search by Name"
                variant="standard"
                value={search.searchText}
                onChange={(e) =>
                  setSearch({ ...search, searchText: e.target.value })
                }
                onKeyPress={handleKeyPress}
                InputProps={{
                  endAdornment: search.searchText ? (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onClick={handleSearchCancel}
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                className={`search-field search-field--${themechange}`}
              />
              <IconButton
                onClick={handleSearchClick}
                style={{
                  fontSize: "12px",
                  width: "30px",
                  minWidth: "30px",
                  fontWeight: 400,
                  color: "var(--Searchtext_muted)",
                  fontFamily: "Roboto",
                  textAlign: "left",
                  justifySelf: "right",
                  cursor: "pointer",
                  textTransform: "none",
                  marginLeft: "0px",
                  padding: 0,
                }}
              >
                <SearchIcon
                  color={theme === "light" ? "#3C3C3C" : "#C1C1C1"}
                  width={30}
                  height={30}
                />
              </IconButton>
              <CustomButton
                buttonText={"+Add Customer"}
                onClick={() => setOpenForm(true)}
              />
            </Box>
          </Box>

          <TableContainer
            component={Paper}
            className="table-container"
            elevation={0}
          >
            <Table stickyHeader className="customers-table" size="small">
              <TableHead>
                <TableRow className="table-header-row">
                  <TableCell
                    className="table-header-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablehead.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablehead.fontweight,
                    }}
                  >
                    Customer Name
                  </TableCell>
                  <TableCell
                    className="table-header-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablehead.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablehead.fontweight,
                    }}
                  >
                    Sanction Load
                  </TableCell>
                  <TableCell
                    className="table-header-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablehead.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablehead.fontweight,
                    }}
                  >
                    Billing Cycle
                  </TableCell>
                  <TableCell
                    className="table-header-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablehead.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablehead.fontweight,
                    }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    className="table-header-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablehead.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablehead.fontweight,
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayCustomers.map((customer) => (
                  <TableRow key={customer.id} className="table-body-row">
                    <TableCell
                      component="th"
                      scope="row"
                      className="table-body-cell"
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                      }}
                    >
                      {formatFullName(customer)}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className="table-body-cell"
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                      }}
                    >
                      {customer.data.sanctionLoad}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className="table-body-cell"
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                      }}
                    >
                      {customer.data.billingCycle}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className={`table-body-cell status-cell status-cell--${customer.data.status?.toLowerCase()}`}
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                      }}
                    >
                      {customer.data.accountStatus}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className="table-body-cell"
                      sx={{
                        fontSize:
                          props.widgetprop.props.extended.tablerows.fontsize,
                        fontWeight:
                          props.widgetprop.props.extended.tablerows.fontweight,
                      }}
                    >
                      <CustomerActions
                        customer={customer}
                        setCustomers={setCustomers}
                        setOpenForm={setOpenForm}
                        setCustomerInfo={setCustomerInfo}
                        setFormMode={setFormMode}
                        setDeleteSuccess={setDeleteSuccess}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
}
